// **Redux Imports
import { createSlice } from '@reduxjs/toolkit'

// constant
const initialFilters = { query: '', page: 0, pageSize: 10 }

export const jobDescriptionSlice = createSlice({
  name: 'jobDescription',
  initialState: {
    filters: { ...initialFilters },
    selectedJD: {}
  },
  reducers: {
    setJobDescriptionFilters(state, action) {
      state.filters = action.payload
    },
    setSelectedJobDescription(state, action) {
      state.selectedJD.general = action.payload
    }
  }
})

export const { setJobDescriptionFilters, setSelectedJobDescription } =
  jobDescriptionSlice.actions

export default jobDescriptionSlice.reducer
